 const happeningData = [
    {
        id: 1,
      title: "Trending in India",
      name: "#SakshiMalik",
      tweets: "1000 Tweets",
      Names: "RVCJ ",
      email: "@RVCJ_",
      isFollow: true,
      image:
        "https://media.licdn.com/dms/image/C4D03AQGbbiS8O7oSeA/profile-displayphoto-shrink_800_800/0/1616177201859?e=2147483647&v=beta&t=ae08hpJ3aBCObsnRj1VRiQVU7xzqJ_DUOJnhfEKRl44",
    },
    {
        id: 2,
      title: "Trending in India",
      name: "#ShareMarket",
      tweets: "10.1k Tweets",
      Names: "Ashwani",
      email: "@ashwani",
      isFollow: true,
      image:
        "https://media.licdn.com/dms/image/D4E03AQElUX_252X3OQ/profile-displayphoto-shrink_800_800/0/1665254295747?e=2147483647&v=beta&t=AN6tZLLbfvjDJ4LfR1G2Bf_myIiEgXfnUiRc9DkoBsM",
    },
    {
        id: 3,
      title: "Trending in Sports",
      name: "#ViratKholi",
      tweets: "2000 Tweets",
      Names: "aramco",
      email: "@aramco",
      isFollow: true,
      image:
        "https://www.ubetoo.com/wp-content/uploads/2020/04/Dumi-Mkokstad-in-support-of-conspiracy-theory-on-the-relation.jpg",
    },
    {
        id: 4,
      title: "Trending in Plitics",
      name: "#Modi",
      tweets: "10.2k Tweets",
      Names: "IDFC Bank",
      email: "@IDFC",
      isFollow: true,
      image:
        "https://i0.wp.com/wikibiostars.in/wp-content/uploads/2022/12/Dumi-Mkokstad.jpg",
    },
    {
        id: 5,
      title: "Trending in Bollywood",
      name: "#AmirKhan",
      tweets: "3.2k Tweets",
      Names: "AmirKhan",
      email: "@amir",
      isFollow: true,
      image:
        "https://i0.wp.com/wikibiostars.in/wp-content/uploads/2022/12/Dumi-Mkokstad.jpg",
    },
    {
        id: 6,
      title: "Trending in Bollywood",
      name: "#salmanKhan",
      tweets: "1.2k Tweets",
      Names: "salman",
      email: "@salman",
      isFollow: true,
      image:
        "https://i0.wp.com/wikibiostars.in/wp-content/uploads/2022/12/Dumi-Mkokstad.jpg",
    },
    {
        id: 7,
      title: "Trending in Hollywood",
      name: "#Priyanka",
      tweets: "10k Tweets",
      Names: "Priyanka",
      email: "@priyanka",
      isFollow: true,
      image:
        "https://i0.wp.com/wikibiostars.in/wp-content/uploads/2022/12/Dumi-Mkokstad.jpg",
    },
  ];

  export default happeningData;